import {
  Typography,
  Button,
  makeStyles,
  Box,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useState } from "react";

import DialogCloseButton from "../components/DialogCloseButton";
import settings, { changeBranch } from "../utils/settings";

const useStyles = makeStyles((theme) => ({
  background: {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100vh",
    left: 0,
    backgroundColor: "#424242dd",
    width: "100%",

    zIndex: 999,
    display: "grid",
    placeItems: "center",
  },
  allContainer: {
    backgroundColor: theme.white,
    width: 400,
    height: 250,
    borderRadius: 12,
    position: "relative",
  },
  title: {
    fontSize: 30,
    color: theme.orange,
    marginTop: 10,
  },

  content: {
    width: "100%",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 50,
    boxSizing: "border-box",
    display: "grid",
    placeContent: "center",
  },
  button: {
    position: "absolute",
    bottom: 0,
    left: 0,
    fontSize: 24,
    borderRadius: "0 0 12px 12px",
  },
  selectEmpty: {
    width: "300px",
  },
}));

const DialogBranchSelection = ({ title = "Branch selection", onClose }) => {
  const classes = useStyles();
  let { branches, branchId } = settings();
  //branches.unshift({ id: -1, name: "All" });

  const [selectedBranch, setSelectedBranch] = useState(branchId);
  return (
    <Box className={classes.background}>
      <Box className={classes.allContainer}>
        <Typography align="center" classes={{ root: classes.title }}>
          {title}
        </Typography>
        <DialogCloseButton onClose={onClose} />
        <Box className={classes.content}>
          <Select
            value={selectedBranch}
            onChange={(event) => setSelectedBranch(event.target.value)}
            displayEmpty
            className={classes.selectEmpty}
            inputProps={{ "aria-label": "Without label" }}
          >
            {branches.map((branch) => {
              return <MenuItem value={branch.id}>{branch.name}</MenuItem>;
            })}
          </Select>
        </Box>
        <Button
          onClick={() => {
            changeBranch(
              selectedBranch,
              branches.find((branch) => branch.id === selectedBranch).name
            );
            window.location.reload();
            // forceUpdate();
          }}
          disabled={false}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
        >
          OK
        </Button>
      </Box>
    </Box>
  );
};

export default DialogBranchSelection;
